const translations = "Enregistrez votre signature manuscrite pour simplifier et accélérer vos souscriptions";

export default translations;
